import React from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';

import Theme from '../common/NekoTheme';
import { useClasses } from '../hooks';

const NekoH1 = Styled.h1`
  font-family: ${Theme.fontFamily};
  font-weight: normal;
  font-size: ${Theme.fontSizeH1};
  line-height: normal;
  margin-top: 0;
  margin-bottom: 16px;
  padding: 0;
`;

const NekoH2 = Styled.h2`
  font-family: ${Theme.fontFamily};
  font-size: ${Theme.fontSizeH2};
  font-weight: normal;
  line-height: normal;
  margin-top: 0;
  margin-bottom: 16px;
  padding: 0;
`;

const NekoP = Styled.p`
  font-family: ${Theme.fontFamily};
  font-size: ${Theme.fontSizeText};
  line-height: normal;
  margin: 16px 0 24px;
  padding: 0;
`;

const NekoSpan = Styled.span`
  font-family: ${Theme.fontFamily};
  font-size: ${Theme.fontSizeText};
  line-height: normal;
  margin: 0;
  padding: 0;
`;

const NekoLabel = Styled.label`
  font-family: ${Theme.fontFamily};
  font-size: ${Theme.fontSizeText};
  line-height: normal;
  margin: 0;
  padding: 0;
`;

/**
 * @param {string} (variant) Tag Name
 */
const StyledNekoTypo = props => {
  const { children, style, className, ...rest } = props;
  const boldStyle = props.bold ? { fontWeight: 'bold' } : {};
  const classNames = useClasses('neko-typo', className, { 'neko-typo-h1': props.h1 }, { 'neko-typo-h2': props.h2 }, { 'neko-typo-p': props.p }, { 'neko-typo-label': props.label });

  return (
    props.h1 ? <NekoH1 style={{ ...boldStyle, ...style }} className={classNames} {...rest}>{children}</NekoH1>
    : props.h2 ? <NekoH2 style={{ ...boldStyle, ...style }} className={classNames} {...rest}>{children}</NekoH2>
    : props.p ? <NekoP style={{ ...boldStyle, ...style }} className={classNames} {...rest}>{children}</NekoP>
    : props.label ? <NekoLabel style={{ ...boldStyle, ...style }} className={classNames} {...rest}>{children}</NekoLabel>
    : <NekoSpan style={{ ...boldStyle, ...style }} className={classNames} {...rest}>{children}</NekoSpan>
  );
};

const NekoTypo = (props) => {
  return (<StyledNekoTypo {...props} />);
}

NekoTypo.propTypes = {
  h1: PropTypes.any,
  h2: PropTypes.any,
  p: PropTypes.any
};

NekoTypo.defaultProps = {
  h1: undefined,
  h2: undefined,
  p: undefined
};

export { NekoTypo };
